import React from "react";
import { Icon } from "@iconify/react";
import {
  Box,
  Paper,
  Typography,
  Avatar,
  IconButton,
} from "@mui/material";
import { RequireAuth } from "../../../RequireAuth";

const CenterDetails = ({
  center,
  onEdit,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        flexWrap: { xs: "wrap", md: "nowrap" },
        fontFamily: "Figtree",
        marginBottom:"2%",
        width:"100%"
      }}
    >
      {/* ================= LEFT : CENTRE DETAILS ================= */}
      <Paper
        elevation={0}
        sx={{
          flex: "1 1 73%",
          p: 3,
          borderRadius: "16px",
        }}
      >
        <Typography  sx ={{fontSize:"20px", fontWeight:"700"}} mb={2}>
          Centre Details
        </Typography>

        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Avatar
              src={center?.logo || "https://weazy.in/assets/team/see.jpg"}
              variant="rounded"
              sx={{ width: 56, height: 56, border:"1px solid var(--app-border)", borderRadius:"8px" }}
            />
            <Box>
              <Typography fontWeight={700} sx={{fontFamily: "figtree", fontSize:"17px"}}> {center?.name?.charAt(0)?.toUpperCase() + center?.name?.slice(1)}</Typography>
              <Typography fontSize={16} sx={{color:"var(--app-text)", fontSize:"16px", fontWeight:"600"}}>
                {center?.type?.charAt(0)?.toUpperCase() + center?.type?.slice(1)}
              </Typography>
            </Box>
          </Box>

          <RequireAuth role={["b2b"]} permission="canManageUsers">
            <IconButton
              onClick={onEdit}
              sx={{
                bgcolor: "var(--app-surface-2)",
                borderRadius: "8px",
                "&:hover": { bgcolor: "var(--app-surface-2)" },
              }}
            >
              <Icon
                icon="material-symbols:edit"
                width="20"
                height="20"
                style={{ color: "#5751E9" }}
              />
            </IconButton>
          </RequireAuth>
        </Box>

        {/* Contact + Address */}
        <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap", mb: 3 }}>
          <InfoBlock label="CONTACT NUMBER" value={center?.fullPhone} />
          <InfoBlock
            label="ADDRESS"
            value={center?.address?.fulladdress}
            grow
          />
          {center?.centerType === "spoke" && (
            <InfoBlock
              label="HUB CENTRE"
              value={center?.hierarchy?.[1]?.name}
            />
          )}
        </Box>

        <DividerLine />

        {/* Billing */}
        <Typography fontSize={16} fontWeight={700} mb={2}>
          Billing Details
        </Typography>

        <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
          <InfoBlock label="NAME" value={center?.billingName} />
          <InfoBlock
            label="BILLING ADDRESS"
            value={center?.billingAddress}
            grow
          />
          <InfoBlock label="TAX ID" value={center?.taxId} />
          {/* <InfoBlock label="TAX STATE CODE" value={center?.taxCode} /> */}
        </Box>
      </Paper>

      {/* ================= RIGHT : HIERARCHY ================= */}
      <Paper
        elevation={0}
        sx={{
          flex: "1 1 25%",
          p: 3,
          borderRadius: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          {center?.hierarchy?.map((level, idx) => {
            const isLast = idx === center.hierarchy.length - 1;
            return (
              <Box key={idx} sx={{ textAlign: "center" }}>
                <Paper
                  elevation={0}
                  sx={{
                    px: 3,
                    py: 1.5,
                    bgcolor: isLast ? "var(--app-unread)" : "var(--app-surface-2)",
                    borderRadius: "8px",
                    fontWeight: isLast ? 700 : 500,
                    minWidth: 180,
                  }}
                >
                  {level.name}
                </Paper>

                {!isLast && (
                  <Box
                    sx={{
                      width: "1px",
                      height: 87,
                      bgcolor: "var(--app-border)",
                      mx: "auto",
                    }}
                  />
                )}
              </Box>
            );
          })}
        </Box>
      </Paper>
    </Box>
  );
};

export default CenterDetails;

/* ================= HELPERS ================= */

const InfoBlock = ({ label, value, grow }) => (
  <Box sx={{ minWidth: grow ? 260 : "auto", flex: grow ? 1 : "unset" }}>
    <Typography fontSize={12} fontWeight={800} color="#A3A3A3">
      {label}
    </Typography>
    <Typography>{value || "-"}</Typography>
  </Box>
);

const DividerLine = () => (
  <Box sx={{ borderTop: "1px solid var(--app-border)", my: 3 }} />
);
